import { Frame } from 'lucide-react';
import { DesignsList } from '@/features/designs/DesignsList';

export function WallsAnalysisIndexPage() {
  return (
    <DesignsList
      module="analysis_muros"
      description="Análisis estructural de muros — abre uno guardado o crea uno nuevo."
      icon={<Frame size={24} strokeWidth={1.5} />}
    />
  );
}
